export default {
    next_step: 'Next',
    previous_step: 'Previous',
    choose_booth: 'Choose Booth',
    fixed_fee: 'Pay Fixed Fee',
    rent_goods: 'Rent Goods',
    settlement: 'Confirm Settlement',
    payment: 'Pay Fees'
  }


// WEBPACK FOOTER //
// ./src/i18n/en-us/fee.js